<template>
  <main class="main">
    <div class="anim-wrap">
      <div class="mono-logo-container text-center">
        <img src="@/assets/logo_white.svg" alt="Traitstack" />
      </div>
      <div class="field-error" :class="{ toggled: error }">
        {{ errorMessage }}
      </div>
      <div id="authPanel" class="panel auth-panel">
        <div v-if="phase == 0">
          <h1 class="h2">Sign up</h1>
          <form action="javascript:void(0);">
            <input
              v-if="!firstEmailAddress"
              type="text"
              name="email"
              v-model="email"
              class="form-control"
              ref="email"
              placeholder="Email address"
            />
            <input
              type="password"
              name="password"
              v-model="password"
              class="form-control"
              placeholder="Password"
            />
            <button
              type="submit"
              name="submit"
              @click="createAccountRegular"
              class="btn btn-primary btn-auth btn-loader"
              :class="{ active: loading, success: success }"
            >
              <span>Create your account</span>
            </button>
            <p style="margin-top: 20px" class="text-center">
              By signing up, you accept Traitstack<br />
              <a target="_blank" href="https://traitstack.com/privacy-policy"
                >Privacy Policy</a
              >
              and
              <a
                target="_blank"
                href="https://traitstack.com/terms-and-conditions"
                >Terms and Conditions</a
              >.
            </p>
          </form>
          <div class="divider-text">
            <span>or sign up with</span>
          </div>
          <div class="row">
            <div class="col-md-6">
              <button
                @click="createAccountWithGoogle"
                class="btn btn-secondary btn-auth"
              >
                <img src="@/assets/icon_google.png" alt />
                <span>Google</span>
              </button>
            </div>
            <div class="col-md-6">
              <button
                @click="createAccountWithFacebook"
                class="btn btn-secondary btn-auth"
              >
                <img src="@/assets/icon_facebook.png" alt />
                <span>Facebook</span>
              </button>
            </div>
          </div>
          <p class="auth-info">
            Have an Traitstack account already?
            <router-link to="/sign-in">Sign in</router-link>
          </p>
        </div>
        <div v-if="phase == 1">
          <h1 class="h2">Complete details</h1>
          <form action="javascript:void(0);">
            <input
              ref="firstname"
              name="firstname"
              type="text"
              v-model="firstName"
              class="form-control"
              placeholder="First name"
            />
            <input
              type="text"
              name="lastname"
              v-model="lastName"
              class="form-control"
              placeholder="Last name"
            />
            <label>Country</label>
            <multiselect
              v-model="countryObject"
              :options="countries"
              placeholder="Select country"
              deselectLabel
              :multiple="false"
              label="name"
              :close-on-select="true"
              :clear-on-select="true"
              track-by="cca2"
            ></multiselect>
            <label>Gender</label>
            <multiselect
              v-model="gender"
              :options="genders"
              :multiple="false"
              placeholder="Select gender"
              :close-on-select="true"
              :clear-on-select="true"
            ></multiselect>
            <label>Age</label>
            <input
              type="number"
              name="age"
              v-model="age"
              class="form-control"
              ref="number"
              placeholder="Age"
            />
            <label>Industry</label>
            <multiselect
              v-model="industryObject"
              :options="industries"
              :multiple="false"
              placeholder="Select industry"
              label="name"
              :close-on-select="true"
              :clear-on-select="true"
              track-by="id"
              @input="clearSubIndustry()"
            ></multiselect>
            <div :class="{ disabled: !industryObject }">
              <label>Subindustry</label>
              <multiselect
                v-model="subIndustryObject"
                :options="filteredsubIndustries"
                :multiple="false"
                placeholder="Select subindustry"
                label="name"
                :close-on-select="true"
                :clear-on-select="true"
                track-by="id"
              ></multiselect>
            </div>
            <button
              type="submit"
              name="submit"
              @click="updateAccount"
              class="btn btn-primary btn-auth btn-loader"
              :class="{ active: loading, success: success }"
            >
              <span>Continue</span>
            </button>
          </form>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
var _ = require("lodash");

// FireBase
import firebase from "firebase/app";
import "firebase/auth";
import { db } from "../main.js";

import { countries, industries, subIndustries } from "@/assets/static.js";
import { mapState } from "vuex";

export default {
  name: "SignUp",
  components: {},
  data() {
    return {
      firstName: null,
      lastName: null,
      countries: countries,
      industries: industries,
      subIndustries: subIndustries,
      country: null,
      countryObject: null,
      industry: null,
      industryObject: null,
      gender: null,
      genders: ["Male", "Female", "Other"],
      subIndustry: null,
      subIndustryObject: {
        code: "notspecified",
        id: "1",
        name: "Not specified",
      },
      phase: 0,
      age: null,
      email: "",
      password: "",
      loading: false,
      error: false,
      errorMessage: "",
      success: false,
      firstPassword: null,
      firstEmailAddress: null,
    };
  },
  computed: {
    ...mapState(["user"]),
    ...mapState(["userData"]),
    getUser() {
      return this.user ? this.user : "";
    },
    getUserData() {
      return this.userData ? this.userData : "";
    },
    filteredsubIndustries() {
      if (this.industryObject) {
        if (this.industryObject.id == 1) {
          return [{ code: "notspecified", id: "1", name: "Not specified" }];
        } else {
          return _.orderBy(
            _.filter(_.orderBy(this.subIndustries, "id", "asc"), {
              parent_id: this.industryObject.id,
            }),
            ["id"],
            ["asc"]
          );
        }
      } else {
        return [{ code: "notspecified", id: "1", name: "Not specified" }];
      }
    },
  },
  mounted() {
    this.firstPassword = this.$route.query.hash;
    this.firstEmailAddress = this.$route.query.email;
    this.$refs.email.focus();
    if (this.getUser) {
      this.phase = 1;
      this.$nextTick(() => this.$refs.firstname.focus());
      this.prepopulateData();
    }
  },
  methods: {
    resetErrorState() {
      this.loading = false;
      this.success = false;
      this.error = false;
    },
    displayErrorPanelWithMessage(message) {
      this.errorMessage = message;
      this.loading = false;
      this.error = true;
      document.getElementById("authPanel").classList.remove("error");
      void document.getElementById("authPanel").offsetWidth;
      document.getElementById("authPanel").classList.add("error");
    },
    clearSubIndustry() {
      this.subIndustry = null;
    },
    prepopulateData() {
      if (this.getUserData) {
        if (this.getUserData.gender) {
          this.gender = this.getUserData.gender;
        }

        if (this.getUserData.age) {
          this.age = this.getUserData.age;
        } else {
          this.age = 18;
        }

        if (this.getUserData.country) {
          this.country = this.getUserData.country;
          this.countryObject = countries.find(
            ({ cca2 }) => cca2 === this.country
          );
        }

        if (this.getUserData.industry) {
          this.industry = this.getUserData.industry;
          this.industryObject = industries.find(
            ({ id }) => id === this.industry
          );
        }

        if (this.getUserData.subIndustry) {
          this.subIndustry = this.getUserData.subIndustry;
          this.subIndustryObject = subIndustries.find(
            ({ id }) => id === this.subIndustry
          );
        }

        if (this.getUserData.firstName) {
          this.firstName = this.getUserData.firstName;
        }

        if (this.getUserData.lastName) {
          this.lastName = this.getUserData.lastName;
        }

        this.extractSocialName();
      }
    },
    extractSocialName() {
      let user = firebase.auth().currentUser;
      if (!this.firstName && !this.lastName) {
        if (user.displayName) {
          let names = user.displayName.split(" ");
          if (names[0]) {
            this.firstName = names[0];
          }
          if (names[1]) {
            this.lastName = names[1];
          }
        }
      }
    },
    signUpWithSocial(provider) {
      firebase
        .auth()
        .signInWithPopup(provider)
        .then((result) => {
          // check if new user
          if (result.additionalUserInfo.isNewUser) {
            let acceptPolicies = firebase
              .functions()
              .httpsCallable("acceptPolicies");

            acceptPolicies()
              .then(() => {
                this.phase = 1;
                this.extractSocialName();
                this.$nextTick(() => this.$refs.firstname.focus());
                this.error = false;
                this.loading = false;
                this.success = false;
              })
              .catch((error) => {
                this.displayErrorPanelWithMessage(error.messge);
              });
          } else {
            setTimeout(() => {
              this.loading = false;
              this.success = false;
              this.error = false;
              this.$router.replace({ path: "/" });
            }, 1500);
          }
        })
        .catch((error) => {
          this.displayErrorPanelWithMessage(error.messge);
        });
    },
    linkAccountWithSocial(provider) {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.firstEmailAddress, this.firstPassword)
        .then(() => {
          let user = firebase.auth().currentUser;
          user
            .linkWithPopup(provider)
            .then(() => {
              this.$store.commit("updateAcceptedPolicies", true);

              let acceptPolicies = firebase
                .functions()
                .httpsCallable("acceptPolicies");

              acceptPolicies()
                .then(() => {
                  this.extractSocialName();
                  this.phase = 1;
                  this.error = false;
                  this.$nextTick(() => this.$refs.firstname.focus());
                  this.resetErrorState();
                })
                .catch((error) => {
                  this.displayErrorPanelWithMessage(error.message);
                });
            })
            .catch((error) => {
              this.displayErrorPanelWithMessage(error.message);
            });
        });
    },
    claimAccountAndUpdatePassword() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.firstEmailAddress, this.firstPassword)
        .then(
          () => {
            let user = firebase.auth().currentUser;
            user
              .updatePassword(this.password)
              .then(() => {
                this.loading = false;
                this.success = true;
                this.error = false;

                let acceptPolicies = firebase
                  .functions()
                  .httpsCallable("acceptPolicies");
                console.log("acceptPolicies bro");
                acceptPolicies()
                  .then(() => {
                    this.phase = 1;
                    this.$nextTick(() => this.$refs.firstname.focus());
                    this.error = false;
                    this.loading = false;
                    this.success = false;
                  })
                  .catch((error) => {
                    this.displayErrorPanelWithMessage(error.messge);
                  });
              })
              .catch((error) => {
                this.$toast.open({
                  message: error.message,
                });
                firebase
                  .auth()
                  .signOut()
                  .then(
                    () => {
                      this.resetErrorState();
                    },
                    (error) => {
                      console.error("Sign Out Error", error);
                    }
                  );
              });
          },
          (error) => {
            this.displayErrorPanelWithMessage(error.message);
          }
        );
    },
    createAccountWithEmailAndPassword() {
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(
          () => {
            this.$store.commit("updateAcceptedPolicies", true);

            let acceptPolicies = firebase
              .functions()
              .httpsCallable("acceptPolicies");

            acceptPolicies()
              .then(() => {
                this.phase = 1;
                this.$nextTick(() => this.$refs.firstname.focus());
                this.error = false;
                this.loading = false;
                this.success = false;
              })
              .catch((error) => {
                this.displayErrorPanelWithMessage(error.message);
              });
          },
          (error) => {
            this.displayErrorPanelWithMessage(error.message);
          }
        );
    },
    createAccountWithFacebook() {
      this.$store.commit("updateAcceptedPolicies", true);
      if (this.loading) {
        return;
      }
      var provider = new firebase.auth.FacebookAuthProvider();
      this.loading = true;
      // if account is already created (invited user)
      if (this.firstPassword !== undefined) {
        this.linkAccountWithSocial(provider);
      } else {
        this.signUpWithSocial(provider);
      }
    },
    createAccountWithGoogle() {
      this.$store.commit("updateAcceptedPolicies", true);
      if (this.loading) {
        return;
      }
      var provider = new firebase.auth.GoogleAuthProvider();
      this.loading = true;
      // if account is already created (invited user)
      if (this.firstPassword !== undefined) {
        this.linkAccountWithSocial(provider);
      } else {
        this.signUpWithSocial(provider);
      }
    },
    createAccountRegular() {
      this.$store.commit("updateAcceptedPolicies", true);
      if (this.loading) {
        return;
      }
      this.loading = true;
      if (this.firstPassword !== undefined) {
        this.claimAccountAndUpdatePassword();
      } else {
        this.createAccountWithEmailAndPassword();
      }
    },
    updateAccount() {
      if (this.loading) {
        return;
      }
      const userData = this.getUser;
      const uid = userData.uid;

      const data = {
        firstName: this.firstName,
        lastName: this.lastName,
        gender: this.gender,
        age: this.age,
      };

      // If country populated
      if (this.countryObject) {
        data.country = this.countryObject.cca2;
      } else {
        data.country = null;
      }

      // If industry populated
      if (this.industryObject) {
        data.industry = this.industryObject.id;
      } else {
        data.industry = null;
      }

      // If subindustry populated
      if (this.subIndustryObject) {
        data.subIndustry = this.subIndustryObject.id;
      } else {
        data.subIndustry = null;
      }

      if (uid) {
        this.loading = true;
        var batch = db.batch();

        // Update user details
        var userRef = db.collection("users").doc(uid);
        batch.update(userRef, data);

        // Update shared name
        var userSharedRef = db
          .collection("users")
          .doc(uid)
          .collection("shared")
          .doc(uid);

        batch.update(userSharedRef, {
          firstName: this.firstName,
          lastName: this.lastName,
        });

        // Commit the batch
        batch
          .commit()
          .then(() => {
            this.loading = false;
            this.success = true;
            this.error = false;
            setTimeout(() => {
              this.$router.replace({ path: "/" });
            }, 500);
          })
          .catch((err) => {
            this.$toast.open({
              message: err.message,
            });
            this.loading = false;
            this.success = true;
            this.error = false;
            setTimeout(() => {
              this.$router.replace({ path: "/" });
            }, 500);
          });
      }
    },
  },
};
</script>
